export enum FieldOrigin {
  SF_STANDARD = 'SF_STANDARD', //cannot be deleted/edited
  SF_CUSTOM = 'SF_CUSTOM', //cannot be deleted
  SWEEP_CUSTOM = 'SWEEP_CUSTOM', //can be deleted
  MP_CUSTOM = 'MP_CUSTOM', //cannot be deleted/edited
}
